export default __webpack_public_path__ + "static/media/03-rock-dx-old.e9021975.gif";